import { useEffect, useState } from "react";
import Navbar1 from "../navbar/Navbar1";
import Footer from "./Footer";
import Spinner from "../../Spinner";

export default function CustomPage({ component }) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simula una carga asincrónica (puedes reemplazar esto con tu lógica real)
    setTimeout(() => {
      setLoading(false); // Detener el spinner después de 2 segundos (simulación)
    }, 1000);
  }, []);
  return (
    <div>
      {loading ? (
        <>
          <div>
            <div className="slide-1"></div>
            <div className="slide-2"></div>
            <div className="slide-3"></div>
            <div className="slide-4"></div>
            <Spinner />
          </div>
        </>
      ) : (
        <>
          <Navbar1 />
          {component}
          <Footer />
        </>
      )}
    </div>
  );
}
